<style>

</style>

<div bind:clientWidth="{height}">
  {#if loaded}
  <img src="{src}" style="height: {height}px; {style}" alt="{alt}">
  {/if}
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let src = "";
export let style = "";
export let alt = "blank image";

let height = 100;
let loaded = false;

$:{
  if (src) set();
}


function set() {
  if (src.includes("data:image/") == false) {
    src = src.replace(/cookie/gi, localStorage.getItem("cookie"));
    src = src.replace(/csrf/gi, localStorage.getItem("csrf"));
    src = "https://routes.hot0.workers.dev" + src;
    // console.log("src:", src);
  }
  
  if (src.includes("undefined") == false) loaded = true;
}

</script>